import React, { Component, PropTypes } from 'react';

import './NoBookingsMessage.css';

export default class NoBookingsMessage extends Component {
    render() {
        return (
            <div className="no-bookings-message">
                <div>You have no bookings</div>
                <div>
                    <i className="material-icons">&#xE5D5;</i><br />
                    try refreshing
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./scripts/components/Calendar/NoBookingsMessage.jsx